import { ISysNotification } from "../interface/sys-notification";
import axiosInstance from "./instance";

export const RequestGetSysNotifications = (addNotification: any, data?: any): Promise<ISysNotification[]> => {
    return new Promise<ISysNotification[]>((resolve, reject) => {
        let url = `/sysNotifications/`;
        if (data) {
            url += "?";
            for (let [key, value] of Object.entries(data)) {
                url += key + '=' + value + "&";
            }
        }
        axiosInstance(addNotification).get(url).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            // console.log(response);
            resolve(response)

        }).catch(exc => {
            // console.log(exc);
            reject(exc);
        });
    })
}

export const RequestGetSysNotification = (addNotification: any, id: string): Promise<ISysNotification> => {
    return new Promise<ISysNotification>((resolve, reject) => {

        axiosInstance(addNotification).get(`/sysNotifications/${id}`).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            //  console.log(response);
            resolve(response)

        }).catch(exc => {
            //   console.log(exc);
            reject(exc);
        });
    })
}


export const RequestNewSysNotification = (addNotification: any, thing: ISysNotification): Promise<ISysNotification> => {
    return new Promise<ISysNotification>((resolve, reject) => {

        axiosInstance(addNotification).post(`/sysNotifications/`, thing).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}
export const RequestDeleteSysNotification = (addNotification: any, thing: ISysNotification): Promise<boolean> => {
    return new Promise<boolean>((resolve, reject) => {

        axiosInstance(addNotification).delete(`/sysNotifications/delete/${thing.id}`).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}
export const RequestUpdateSysNotification = (addNotification: any, user: ISysNotification): Promise<ISysNotification> => {
    return new Promise<ISysNotification>((resolve, reject) => {

        axiosInstance(addNotification).patch(`/sysNotifications/${user.id}`, user).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            console.log(response);
            resolve(response)

        }).catch(exc => {
            console.log(exc);
            reject(exc);
        });
    })
}

export const RequestSysNotificationFunction = (addNotification: any, func:string, id: string): Promise<any> => {
    return new Promise<any[]>((resolve, reject) => {
        let url = `/sysNotifications/_func/${func}/${id}`;
        
        axiosInstance(addNotification).get(url).then(response => {
            //   console.log(response);
            if (response === undefined) reject();
            return response.data;
        }).then(response => {
            // console.log(response);
            resolve(response)

        }).catch(exc => {
            // console.log(exc);
            reject(exc);
        });
    })
}

// eslint-disable-next-line
{/*<!-- OPTIONAL 1 -->*/ }

// eslint-disable-next-line
{/*<!-- OPTIONAL END -->*/ }
